(function () {
    'use strict';

    angular.module('core').directive('onlyNumbers', function() {
      return {
        link: function(scope, element) {
          element.on('keypress', function(event) {
            if (event.key && !/[\d\.\b\t]/.test(event.key) && !event.ctrlKey) {
              event.preventDefault();
            }
            if (event.key === '.' && element.val().indexOf('.') !== -1) {
              event.preventDefault();
            }
          });

          element.on('paste', function(event) {
            event.preventDefault();
            var pastedText = (event.originalEvent || event).clipboardData.getData('text/plain');
            var output = handlePasteLocation(element, deleteExtraDots(pastedText.replace(/[^\d.]/g, '')));
            var ngModelCtrl = element.controller('ngModel');
            ngModelCtrl.$setViewValue(output.output);
            ngModelCtrl.$render();
            element[0].setSelectionRange(output.cursorPosition, output.cursorPosition);
          });

          function deleteExtraDots(output) {
            var parts = output.split('.');
            return parts[0] + (parts.length > 1 ? '.' + parts.slice(1).join('') : '');
          }

          function handlePasteLocation(element, textToPaste) {
            var currentValue = element.val();
            var selectionStart = element[0].selectionStart;
            var textBefore = currentValue.substring(0, selectionStart);
            var textAfter = currentValue.substring(element[0].selectionEnd);
            if (textBefore.indexOf('.') != -1 || textAfter.indexOf('.') != -1) {
              textToPaste = textToPaste.replace(/\./g, '');
            }
            return { output: textBefore + textToPaste + textAfter, cursorPosition: selectionStart + textToPaste.length };
          }
        }
      };
    });

})();
